import { Download } from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import * as ds from './dataService';



export type ExternalFolderTableProps = {
  folderId: string;
};

export const FC = ({
  folderId
}: ExternalFolderTableProps) => {
  const { data } = ds.useQuery(folderId);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Filename</TableCell>

            <TableCell>File size</TableCell>

            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {data.rows.map((d) => (
            <TableRow
              content='list'
              key={d.id}
              sx={{
                cursor: 'pointer'
              }}
              onClick={() => window.open(d.url, '_blank')}
            >
              <TableCell variant='firstRounded'>
                {d.fileName}
              </TableCell>

              <TableCell variant='body'>
                {d.formattedFileSize}
              </TableCell>

              <TableCell variant='lastRounded'>
                <Download />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
